import { useState } from "react";
import styled from "styled-components";
import { SectionTitle } from "../components/SectionTitle";

import imageAss from "../assets/gallery/1.png";
import image2 from "../assets/gallery/2.jpeg";
import image3 from "../assets/gallery/3.png";
import image4 from "../assets/gallery/4.jpg";
import image5 from "../assets/gallery/5.jpg";
import you from "../assets/gallery/YOU.JPEG";
import image7 from "../assets/gallery/7.jpeg";
import image9 from "../assets/gallery/9.png";
import image10 from "../assets/gallery/10.jpg";
import about from "../assets/gallery/about.jpg";
import alluring from "../assets/gallery/Alluring.jpeg";
import choking from "../assets/gallery/chocking.jpeg";
import latexSunset from "../assets/gallery/latexSunset.jpeg";
import legsForDays from "../assets/gallery/LegsForDays.jpeg";
import middleF from "../assets/gallery/middleF.jpeg";
import leatherBootsAndCrop from "../assets/gallery/bootsAndCrop.JPEG";
import middleFingerBack from "../assets/gallery/middleFingerBack.JPEG";
import whipBed from "../assets/gallery/whipBed.JPEG";
import balcony from "../assets/gallery/balcony.JPEG";
import champagne from "../assets/gallery/champagne.JPEG";
import profile from "../assets/gallery/profile.JPEG";

import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import { Fullscreen, Slideshow } from "yet-another-react-lightbox/plugins";

const photos = [
  {
    id: "whipBed",
    src: whipBed,
    width: 1650,
    height: 1080,
  },
  {
    id: "middlefingerBack",
    src: middleFingerBack,
    width: 950,
    height: 1650,
  },

  {
    id: "alluring",
    src: alluring,
    width: 1080,
    height: 1650,
  },
  {
    id: "LeatherBootsAndCrop",
    src: leatherBootsAndCrop,
    width: 1200,
    height: 1200,
  },
  {
    id: "imageAss",
    src: imageAss,
    width: 350,
    height: 300,
  },
  {
    id: "about",
    src: about,
    width: 300,
    height: 400,
  },
  {
    id: "strapon",
    src: image3,
    width: 300,
    height: 200,
  },
  {
    id: "redboots",
    src: image4,
    width: 300,
    height: 370,
  },
  {
    id: "profile",
    src: profile,
    width: 1050,
    height: 1400,
  },
  {
    id: "accessories",
    src: image5,
    width: 400,
    height: 300,
  },

  {
    id: "latexSunset",
    src: latexSunset,
    width: 1080,
    height: 1650,
  },
  {
    id: "you",
    src: you,
    width: 400,
    height: 520,
  },
  {
    id: "blackcorset",
    src: image7,
    width: 300,
    height: 370,
  },
  {
    id: "legsForDays",
    src: legsForDays,
    width: 1080,
    height: 1650,
  },

  {
    id: "chairchampagne",
    src: champagne,
    width: 400,
    height: 300,
  },
  {
    id: "cuffsWhip",
    src: image9,
    with: 300,
    height: 300,
  },
  {
    id: "chocking",
    src: choking,
    width: 300,
    height: 500,
  },
  {
    id: "middleF",
    src: middleF,
    width: 1080,
    height: 1650,
  },
  {
    id: "corsetseated",
    src: image10,
    width: 300,
    height: 360,
  },
  {
    id: "boots",
    src: image2,
    width: 300,
    height: 400,
  },
  {
    id: "balcony",
    src: balcony,
    width: 1050,
    height: 1650,
  },
];

export const GallerySection = () => {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <GalleryContainer>
        <SectionTitle title="Gallery" />
        <br />
        {/* <QuoteStyleTextWrapper>
          <QuoteStyleText>Feel the friction. Torturous delights</QuoteStyleText>
        </QuoteStyleTextWrapper> */}

        <p style={{ fontSize: "20px", textAlign: "center" }}>
          Craving more? You can find more content on my{" "}
          <a
            href="https://loyalfans.com/mayamistress"
            styles={{ textDecoration: "underline" }}
          >
            {" "}
            <span style={{ textDecoration: "underline" }}>Loyal Fans</span>
          </a>{" "}
          and Socials
        </p>
        <br />
        <PhotoAlbum
          photos={photos}
          layout="masonry"
          columns={(containerWidth) => {
            if (containerWidth < 500) return 2;
          }}
          onClick={({ index }) => setIndex(index)}
        />
        <Lightbox
          open={index >= 0}
          close={() => setIndex(-1)}
          slides={photos}
          index={index}
          plugins={[Fullscreen, Slideshow]}
        />
      </GalleryContainer>
    </>
  );
};

const GalleryContainer = styled.div`
  background-color: var(--color-obsidian);
  padding: 5rem 2rem;
  margin-top: -5rem;

  @media screen and (max-width: 500px) {
    padding: 1rem 0.5rem;
  }
`;
